<template>
  <v-form v-model="valid" ref="form" lazy-validation class="day">
    <div class="day__head">
      <StatisticEmployeeReportModal
        v-if="accessCheck"
        ref="reportModal_day"
        :create-day="date"
        :function-update="functionUpdate"
        reverse
      />
      <BaseButton
        v-if="accessCheck && formatedDayEdit.find((i) => i.projects.length)"
        @click="edit = !edit"
        default_icon="button-edit"
        icon_only
        reverse
        width="50"
        height="40"
      />
      <div class="day__date">
        <svg
          width="18"
          height="20"
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6Z"
            fill="#BEDBEB"
          />
        </svg>
        <span class="f14">{{ date }}</span>
      </div>
    </div>
    <template v-if="formatedDay.length">
      <div class="report" v-for="(report, index) in formatedDayEdit" :key="index">
        <div class="report__header">
          <div class="work_time">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20ZM12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM17 11.5V13H11V7H12.5V11.5H17Z"
                fill="#EEEEEE"
              />
            </svg>
            <div class="work_time-text f14">
              {{
                report.end
                  ? report.start.split(' ')[0] === report.end.split(' ')[0]
                    ? getTime(report.start) + ' - ' + getTime(report.end)
                    : getTime(report.start) + ' - '
                  : getTime(report.start)
              }}
            </div>
            <template v-if="report.end && report.start.split(' ')[0] !== report.end.split(' ')[0]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20ZM12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2ZM17 11.5V13H11V7H12.5V11.5H17Z"
                  fill="#EEEEEE"
                />
              </svg>
              <div class="work_time-text f14">
                {{  getTime(report.end) + ' (' + formatDate1(report.end.split(' ')[0]) + ')' }}
              </div>
            </template>
          </div>
          <TimeControlShowEmployeeDayLocal
            v-if="report.data && report.data.location.length"
            :locations="report.data.location"
          />
          <StatisticEmployeeReportModal
            v-if="accessCheck"
            ref="reportModal_day"
            :update-day="{ start: report.start, end: report.end }"
            :function-update="functionUpdate"
            :employee_work_day_id="report.id"
          />
          <StatisticEmployeeReportModal
            v-if="accessCheck"
            ref="reportModal"
            :employee_work_day_id="report.id"
            :function-update="functionUpdate"
            :props_dates="{ start: report.start, end: report.end }"
          />
        </div>
        <div class="report__grid" v-if="report.projects.length">
          <BaseAccordion
            v-for="(project, index) in sortProjects(report.projects)"
            :key="index"
            :text="project.project.name"
            :extra="project.project.is_extra == 1"
            type="project"
          >
            <div class="report__project__tables">
              <TimeControlShowEmployeeDayTable
                v-if="project.works.length"
                :work="project.works"
                :index="index"
                :edit="edit"
                :functionUpdate="functionUpdate"
                :report-id="report.id"
              />
              <TimeControlShowEmployeeDayTable
                v-if="project.extras.length"
                :work="project.extras"
                :index="index"
                extra
                :edit="edit"
                :functionUpdate="functionUpdate"
                :report-id="report.id"
              />
            </div>
          </BaseAccordion>
        </div>
        <div v-else class="plug">
          <Plug />
        </div>
      </div>
    </template>
    <BaseButton
      v-if="edit"
      class="mb-4 ml-4"
      @click="onAdminSaveChange"
      :text="localStorage.translations.pages.common.buttons.sohranit"
      default_icon="button-save"
    />
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TimeControlShowEmployeeDayTable from 'components/timeControl/showEmployee/day/TimeControlShowEmployeeDayTable'
import TimeControlShowEmployeeDayLocal from 'components/timeControl/showEmployee/day/TimeControlShowEmployeeDayLocal'
import StatisticEmployeeReportModal from 'components/timeControl/showEmployee/StatisticEmployeeReportModal'

import Plug from 'components/Plug'

export default {
  name: 'TimeControlShowEmployeeDay',
  props: {
    functionUpdate: Function,
    date: [String, Date],
    day: Array,
    periods: Array,
    projectShow: [],
  },
  data() {
    return {
      edit: false,
      valid: true,
      formatedDay: [],
      formatedDayEdit: [],
    }
  },
  components: {
    TimeControlShowEmployeeDayTable,
    TimeControlShowEmployeeDayLocal,
    StatisticEmployeeReportModal,
    Plug,
  },
  computed: {
    ...mapGetters('user', ['userType']),
    reportModal() {
      let result = false
      if (this.$refs.reportModal_day && this.$refs.reportModal_day.modalShow) {
        result = true
      }
      if (result) {
        return result
      }
      for (let i in this.$refs.reportModal) {
        if (this.$refs.reportModal[i] && this.$refs.reportModal[i].modalShow) {
          result = true
          break
        }
      }
      return result
    },
    accessCheck() {
      return this.$userCheckAccess({
        abilities: 'edit_work_days',
      })
    },
  },
  mounted() {
    this.onFormatedDay()
  },
  watch: {
    day() {
      this.onFormatedDay()
    },
    edit() {
      this.onFormatedDay()
    },
    reportModal() {
      this.edit = false
    },
  },
  methods: {
    ...mapActions('employeeWorkDay', [
      'onEmployeeWorkDay_periodReport_post',
      'onEmployeeWorkDay_extra_update',
    ]),
    onFormatedDay() {
      let data = []
      for (let dayReportIndex in this.day) {
        var dayReport = this.day[dayReportIndex]
        var mainObj = {
          data: dayReport.data,
          start: dayReport.start,
          end: dayReport.end,
          id: dayReport.id,
          report: dayReport.report,
          projects: [],
        }
        for (let reportIndex in dayReport.reports) {
          var report = dayReport.reports[reportIndex]
          let obj = {}
          obj.works = []
          obj.extras = []
          obj.project = report.project
          obj.project.is_extra = report.period.is_extra
          const checkProject = (obj) => obj.project.id === report.project.id

          let objWork = {}
          objWork.data = typeof report.data === 'string' ? JSON.parse(report.data) : report.data
          objWork.hours = report.hours
          objWork.size = report.size
          objWork.report = report.report
          objWork.id = report.id
          objWork.employee_period_id = report.employee_period_id
          objWork.old_employee_hours = report.old_employee_hours
          objWork.old_employee_size = report.old_employee_size
          objWork.period = report.period
          objWork.work_type = report.work_type
          if (mainObj.projects.findIndex(checkProject) === -1) {
            obj.works.push(objWork)
            mainObj.projects.push(obj)
          } else {
            let objProjectReady = mainObj.projects[mainObj.projects.findIndex(checkProject)]
            objProjectReady.works.push(objWork)
          }
        }
        for (let extraIndex in dayReport.extras) {
          var extra = dayReport.extras[extraIndex]
          extra.data = typeof extra.data === 'string' ? JSON.parse(extra.data) : extra.data
          const checkProject = (obj) => obj.project.id === extra.project.id
          let obj = {}

          if (mainObj.projects.findIndex(checkProject) === -1) {
            obj.works = []
            obj.extras = []
            obj.project = extra.project
            console.log('this.periods', extra.project.id)
            obj.project.is_extra =
              this.periods.find((i) => i.project_id === extra.project.id) &&
              this.periods.find((i) => i.project_id === extra.project.id).is_extra
            obj.extras.push(extra)
            mainObj.projects.push(obj)
          } else {
            mainObj.projects[mainObj.projects.findIndex(checkProject)].extras.push(extra)
          }
        }
        data.push(mainObj)
      }
      this.onFormatedDayCopy(data)
      this.formatedDay = data
    },
    sortProjects(array) {
      const projects = array.filter((i) => i.project.is_extra === 0)
      const projectsExtra = array.filter((i) => i.project.is_extra === 1)
      let result = projects.concat(projectsExtra)
      return result
    },
    onFormatedDayCopy(data) {
      this.formatedDayEdit = JSON.parse(JSON.stringify(data ? data : this.formatedDay))
    },
    onChangeItemExtra(data) {
      this.changeItems.extra.push(data)
      console.log(data)
    },
    getTime(date) {
      const [, time] = date.split(' ')
      return time
    },
    formatDate1(date) {
      if (date) {
        let result = date.split('-')
        return result[2] + '.' + result[1] + '.' + result[0]
      }
      return ''
    },
    workingTime({ start, end }) {
      if (start && end) {
        let different = new Date(end) - new Date(start)
        let msec = different
        let hours, minuts, seconds
        hours = Math.floor(msec / 1000 / 60 / 60)
        msec -= hours * 1000 * 60 * 60
        minuts = Math.floor(msec / 1000 / 60)
        msec -= minuts * 1000 * 60
        seconds = Math.floor(msec / 1000)
        msec -= seconds * 1000
        let result =
          (hours < 10 ? '0' + hours : hours) +
          ':' +
          (minuts < 10 ? '0' + minuts : minuts) +
          ':' +
          (seconds < 10 ? '0' + seconds : seconds)
        return result
      }
    },
    async onAdminSaveChange() {
      if (this.$refs.form.validate()) {
        if (JSON.stringify(this.formatedDayEdit) !== JSON.stringify(this.formatedDay)) {
          for (let reportKey in this.formatedDayEdit) {
            let report = this.formatedDayEdit[reportKey]
            let reportCheck = this.formatedDay[reportKey]
            for (let projectKey in report.projects) {
              let project = report.projects[projectKey]
              let projectCheck = reportCheck.projects[projectKey]
              for (let workKey in project.works) {
                let work = project.works[workKey]
                let workCheck = projectCheck.works[workKey]
                if (
                  work.hours != workCheck.hours ||
                  work.size != workCheck.size ||
                  work.report != workCheck.report
                ) {
                  let data = {
                    employee_id: this.$route.params.employeeId,
                    employee_period_id: work.employee_period_id,
                    employee_work_day_id: report.id,
                    report: work.report,
                    size: work.size,
                    hours: work.hours,
                  }
                  await this.onEmployeeWorkDay_periodReport_post(data)
                }
              }
              for (let extraKey in project.extras) {
                let extra = project.extras[extraKey]
                let extraCheck = projectCheck.extras[extraKey]
                if (
                  extra.hours != extraCheck.hours ||
                  extra.size != extraCheck.size ||
                  extra.report != extraCheck.report
                ) {
                  let data = {
                    id: extra.id,
                    size: extra.size,
                    hours: extra.hours,
                    report: extra.report,
                  }
                  await this.onEmployeeWorkDay_extra_update(data)
                }
              }
            }
          }
        }
        // this.functionUpdate()
        this.$store.dispatch(
          'popup/onMessage',
          {
            message:
              this.localStorage.translations.pages.common.notifications[
                'izmeneniya-uspeshno-sohraneny'
              ],
            IsError: false,
          },

          { root: true },
        )
        this.functionUpdate({ calendar: true })
        // this.formatedDay = JSON.parse(JSON.stringify(this.formatedDayEdit))
        this.edit = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.day {
  display: grid;
  row-gap: 20px;
  border-radius: 4px;
  background: #dedede;
  border: 1px solid #277faf;

  &__head {
    display: flex;
    justify-content: flex-end;
    background: #dedede;
    gap: 15px;
    padding: 20px 20px 0px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  &__date {
    justify-self: end;
    width: max-content;
    display: flex;
    column-gap: 11px;
    align-items: center;
    padding: 6px 14px;
    background: #277faf;
    border-radius: 10px;

    span {
      color: #ffffff;
    }
  }
}

.work_time {
  background: #277faf;
  border-radius: 10px;
  width: max-content;
  padding: 6px 9px;
  display: flex;
  column-gap: 10px;
  align-items: center;
  align-content: center;

  &-text {
    color: #ffffff;
  }
}

:deep() .plug {
  padding: 10px 0;

  .plug__icon {
    max-width: 150px;
  }

  .plug__text {
    font-size: 2rem !important;
  }
}

.report {
  display: grid;
  // row-gap: 15px;
  background: #ffffff;
  border-radius: 4px;
  padding-bottom: 20px;

  &__header {
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
    // border-bottom: 2px solid #bedbeb;
    width: 100%;
    padding: 20px;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding: 10px;
      grid-template-columns: auto 1fr;
      gap: 10px;
    }
  }

  &__grid {
    display: grid;
    gap: 20px;
  }

  &__project {
    background-color: #ffffff;

    &__tables {
      display: grid;
      row-gap: 20px;
    }
  }

  &__info {
    display: grid;
    grid-template-columns: 1fr 1fr 1.5fr;
    column-gap: 24px;

    &__item {
      background: #ffffff;
      border: 1px solid #ebeff2;

      &__header {
        padding: 16px;
        background: #e4f3fb;
      }

      &__body {
        &--time {
          padding: 25px;
          display: grid;
          row-gap: 17px;

          .item {
            display: grid;
            grid-template-columns: max-content auto max-content;
            align-items: center;
            column-gap: 8px;
          }
        }

        &--geo {
          padding: 25px;
          display: grid;
          row-gap: 17px;

          .item {
            display: grid;
            grid-template-columns: max-content max-content max-content;
            align-items: center;

            svg {
              margin: 0 13px 0 20px;
            }
          }
        }

        &--protocol {
          padding: 8px;
          display: grid;
          row-gap: 8px;

          .item {
            display: grid;
            padding: 24px;
            border: 1px solid #bedbeb;
            row-gap: 8px;

            &__title {
              color: #16558f;
            }

            &__body {
              display: grid;
              grid-template-columns: 1fr max-content;
              gap: 4px;
              justify-content: space-between;

              &__green {
                color: #b4b4b4;
              }
            }
          }
        }
      }
    }
  }
}
</style>